import { Colors } from '@src/colors';
import React, { useEffect, useState } from 'react';
import * as styled from './chart-preview.styled';

const ChartPreview: React.FC<{ title: string }> = ({ title }) => {
    const [barHeights, setBarHeights] = useState<number[]>([]);

    useEffect(() => {
        const heights: number[] = [];

        for (let i = 0; i < 10; i++) {
            heights.push(Math.random() * (100 - 25) + 25);
        }

        setBarHeights(heights);
    }, [title]);

    return (
        <styled.ChartPreview>
            <styled.Title>{title}</styled.Title>
            <styled.BoxWithDashes>
                <p>----</p>
            </styled.BoxWithDashes>
            <styled.BarGraphPreview>
                <styled.GraphBars>
                    <styled.Bar color={Colors.midnight} heightPercentage={barHeights[0]} />
                    <styled.Bar color={Colors.midnight40} heightPercentage={barHeights[1]} />
                    <styled.Bar color={Colors.midnight} heightPercentage={barHeights[2]} />
                    <styled.Bar color={Colors.midnight40} heightPercentage={barHeights[3]} />
                    <styled.Bar color={Colors.midnight} heightPercentage={barHeights[4]} />
                    <styled.Bar color={Colors.midnight40} heightPercentage={barHeights[5]} />
                    <styled.Bar color={Colors.midnight} heightPercentage={barHeights[6]} />
                    <styled.Bar color={Colors.midnight40} heightPercentage={barHeights[7]} />
                    <styled.Bar color={Colors.midnight} heightPercentage={barHeights[8]} />
                    <styled.Bar color={Colors.midnight40} heightPercentage={barHeights[9]} />
                </styled.GraphBars>
                <styled.HorizontalFooterBar />
            </styled.BarGraphPreview>
        </styled.ChartPreview>
    );
};

export default ChartPreview;
